import React from "react";
import { Box } from "@mui/material";
import { BORDER, BRAND, TEXT_PRIMARY, TEXT_SECONDARY } from "./constants";

/**
 * Underlined tabs used across the packaging check pages.
 * counts: { [tabKey]: { value, alert?, color? } }
 */
const TabBar = ({ tabs, tab, onChange, counts = {} }) => (
  <Box
    role="tablist"
    sx={{
      display: "flex",
      gap: 0.5,
      borderBottom: `1px solid ${BORDER}`,
      overflowX: "auto",
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": { display: "none" },
    }}
  >
    {tabs.map(({ key, label }) => {
      const active = tab === key;
      const count = counts[key];
      return (
        <Box
          key={key}
          component="button"
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => onChange(key)}
          sx={{
            flexShrink: 0,
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            minHeight: 44,
            px: 1.75,
            mb: "-1px",
            border: "none",
            borderBottom: `2px solid ${active ? BRAND : "transparent"}`,
            bgcolor: "transparent",
            font: "inherit",
            fontSize: 15,
            fontWeight: active ? 700 : 500,
            whiteSpace: "nowrap",
            cursor: "pointer",
            color: active ? TEXT_PRIMARY : TEXT_SECONDARY,
            transition: "color .15s, border-color .15s",
            "&:hover": { color: TEXT_PRIMARY },
            "&:focus-visible": { outline: `2px solid ${BRAND}`, outlineOffset: -2 },
          }}
        >
          {label}
          {count && (
            <Box
              component="span"
              sx={{ fontSize: 13, fontWeight: 600, color: count.alert ? count.color : TEXT_SECONDARY }}
            >
              ({count.value})
            </Box>
          )}
        </Box>
      );
    })}
  </Box>
);

export default TabBar;
